import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { DatePipe } from '@angular/common';
import { WorkRequirementSharedLibsModule } from './shared-libs.module';
import { WorkRequirementSharedCommonModule } from './shared-common.module';



@NgModule({
    imports: [
        WorkRequirementSharedLibsModule,
        WorkRequirementSharedCommonModule
    ],
    declarations: [
    ],
    providers: [
        DatePipe
    ],
    entryComponents: [],
    exports: [
        WorkRequirementSharedCommonModule,
        DatePipe
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]

})
export class WorkRequirementSharedModule {}



// WEBPACK FOOTER //
// ./src/app/shared/shared.module.ts